import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import DataGridCell from 'components/common/DataGridCell';
import dayjs from 'dayjs';

export function dateTimeCell(params: GridRenderCellParams<string>) {
  let formattedDate = null;
  if (params.value) formattedDate = dayjs(params.value).format('DD/MM/YYYY HH:mm');
  return <DataGridCell content={formattedDate ?? ''} />;
}
